import React from "react";
import { Play } from "lucide-react";
import { about } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function About({ onContact }) {
  const [firstWord, ...rest] = about.title.split(" ");
  const restText = rest.join(" ");

  return (
    <section id="about" className="bg-paper py-20 sm:py-28 lg:py-32">
      <div className="mx-auto grid max-w-[1300px] grid-cols-1 items-center gap-14 px-6 md:px-10 lg:grid-cols-2 lg:gap-20">
        <div className="order-1 lg:order-1">
          <Reveal>
            <p className="inline-block border-b border-bronze pb-2 font-sans text-[11px] uppercase tracking-[0.3em] text-ink/60">
              {about.kicker}
            </p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-6 font-sans text-xl font-light uppercase tracking-[0.3em] sm:text-3xl">
              <span className="text-ink">{firstWord} </span>
              <span className="text-bronze">{restText}</span>
            </h2>
          </Reveal>
          {about.paragraphs.map((para, i) => (
            <Reveal key={i} delay={120 + i * 60}>
              <p className="mt-7 text-[14px] font-light leading-[1.9] text-ink/60">{para}</p>
            </Reveal>
          ))}
          <Reveal delay={320}>
            <div className="mt-9 flex flex-col items-start gap-6">
              <button
                onClick={onContact}
                className="group flex items-center gap-3 bg-bronze/90 px-8 py-3.5 font-sans text-[11px] uppercase tracking-[0.3em] text-[#F1E6D7] transition-all duration-500 hover:bg-bronze"
              >
                {about.primaryCta}
              </button>
              <a
                href={about.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-3"
              >
                <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-ink/60 transition-colors duration-300 group-hover:text-bronze">
                  Follow on YouTube
                </span>
                <span className="h-px w-12 bg-ink/40 transition-all duration-500 group-hover:w-16 group-hover:bg-bronze" />
                <span className="flex h-8 w-8 items-center justify-center rounded-full border border-ink/40 transition-colors duration-300 group-hover:border-bronze">
                  <Play size={11} className="ml-0.5 fill-ink/60 text-ink/60 transition-colors duration-300 group-hover:fill-bronze group-hover:text-bronze" />
                </span>
              </a>
            </div>
          </Reveal>
        </div>

        <div className="order-2 lg:order-2">
          <Reveal delay={120}>
            <div className="group relative overflow-hidden">
              <img
                src={about.img}
                alt="James Green — Global Real Estate Advisor"
                className="h-[480px] w-full object-cover object-[center_12%] transition-transform duration-[1600ms] ease-out group-hover:scale-105 sm:h-[600px] sm:object-[center_18%] lg:h-[640px] lg:object-top"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-ink/10" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
